import React from "react";
import { Box } from "@mui/material";
import TitleBar from "../../components/navbar/TitleBar";
import Footer from "../../components/common/Footer";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import Alerts from "../../components/alerts/Alerts";

export default function SchoolAlerts() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      <Box>
        <TitleBar />
        <SchoolBusNavMenu />
        <Alerts school />
      </Box>
      <Footer />
    </Box>
  );
}
